// EmailVerificationPage.js
import React, { useEffect, useState } from 'react';
import { useBooking } from '../../hooks/useBooking';
import Layout from '../../components/layout/Layout';
import AuthService from '../../services/AuthService';
import { PAGES } from '../../utils/constants';

const EmailVerificationPage = () => {
  const { setCurrentPage } = useBooking();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // Get parameters from URL
        const urlParams = new URLSearchParams(window.location.search);
        const userId = urlParams.get('userId');
        const token = urlParams.get('token');

        if (!userId || !token) {
          setStatus('error');
          setMessage('Invalid verification link');
          return;
        }

        // Call verification API
        await AuthService.verifyEmail(userId, token);
        
        setStatus('success');
        setMessage('Email verified successfully! You can now sign in.');
      } catch (error) {
        setStatus('error');
        setMessage('Email verification failed. The link may be expired or invalid.');
      }
    };

    verifyEmail();
  }, []);

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
          {status === 'verifying' && (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <h1 className="text-xl font-semibold text-gray-900 mb-2">Verifying Email</h1>
              <p className="text-gray-600">{message}</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <div className="text-green-500 text-5xl mb-4">✓</div>
              <h1 className="text-xl font-semibold text-gray-900 mb-2">Email Verified!</h1>
              <p className="text-gray-600 mb-6">{message}</p>
              <button
                onClick={() => {
                  setCurrentPage(PAGES.HOME);
                  window.history.pushState({}, '', '/');
                }}
                className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors"
              >
                Continue to Homepage
              </button>
            </>
          )}
          
          {status === 'error' && (
            <>
              <div className="text-red-500 text-5xl mb-4">✗</div>
              <h1 className="text-xl font-semibold text-gray-900 mb-2">Verification Failed</h1>
              <p className="text-gray-600 mb-6">{message}</p>
              <button
                onClick={() => setCurrentPage(PAGES.HOME)}
                className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-700 transition-colors"
              >
                Back to Homepage
              </button>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default EmailVerificationPage;